var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNrg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ce3c3b",
      fillOpacity: 1
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#c8bdb8"
    },
    cx: 27.5,
    cy: 21,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e9e9e0"
    },
    cx: 27.5,
    cy: 21,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3ccc9"
    },
    d: "M25.379,18.879c0.132-0.132,0.276-0.245,0.425-0.347l-2.361-8.813 c-1.615,0.579-3.134,1.503-4.427,2.796c-1.294,1.293-2.217,2.812-2.796,4.427l8.813,2.361 C25.134,19.155,25.247,19.011,25.379,18.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3ccc9"
    },
    d: "M30.071,23.486l2.273,8.483c1.32-0.582,2.56-1.402,3.641-2.484c1.253-1.253,2.16-2.717,2.743-4.275 l-8.188-2.194C30.255,22.939,29.994,23.2,30.071,23.486z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "13.75px",
      fontFamily: "Allerta",
      InkscapeFontSpecification: "Allerta",
      letterSpacing: ".15000001px",
      fill: "#fff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 22.163355,43.019012 0,9.896241 -1.638184,0 -3.880615,-6.821289 0,6.821289 -1.638184,0 0,-9.896241 1.638184,0 3.880615,6.82129 0,-6.82129 1.638184,0 z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29.752319,52.915253 -1.866455,-3.585205 q -0.04028,0 -0.107422,0.01343 -0.06714,0 -0.214843,0 -0.134278,0 -0.429688,0 -0.281982,0 -0.778808,0 l 0,3.571778 -1.611329,0 0,-9.896241 2.84668,0 q 0.631104,0 1.248779,0.201416 0.617676,0.201416 1.101075,0.604249 0.496826,0.402832 0.792236,0.980224 0.308838,0.563965 0.308838,1.275635 0,1.074219 -0.496826,1.826172 -0.496827,0.751953 -1.342774,1.114502 l 2.25586,3.894043 -1.705323,0 z m -3.397216,-4.753418 1.463623,0 q 0.29541,0 0.59082,-0.09399 0.29541,-0.107422 0.537109,-0.335694 0.241699,-0.228271 0.389405,-0.631103 0.147705,-0.41626 0.147705,-1.020508 0,-0.241699 -0.06714,-0.550537 -0.06714,-0.322266 -0.281982,-0.604248 -0.201416,-0.29541 -0.577393,-0.483399 -0.375977,-0.201416 -0.993652,-0.201416 l -1.208496,0 0,3.920899 z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.993628,47.812714 0,3.826904 q -0.308838,0.389404 -0.698243,0.644531 -0.375976,0.241699 -0.805664,0.402832 -0.416259,0.161133 -0.872802,0.228272 -0.443116,0.06714 -0.886231,0.06714 -0.88623,0 -1.638183,-0.322265 -0.738526,-0.322266 -1.302491,-0.953369 -0.550537,-0.631104 -0.872802,-1.584473 -0.308838,-0.953369 -0.308838,-2.202149 0,-1.248779 0.308838,-2.18872 0.322265,-0.953369 0.872802,-1.584473 0.563965,-0.631103 1.315918,-0.953369 0.751953,-0.335693 1.624756,-0.335693 0.805664,0 1.503906,0.268554 0.698243,0.268555 1.24878,0.805664 l -1.114502,0.993653 q -0.322266,-0.389405 -0.738526,-0.563965 -0.416259,-0.174561 -0.859375,-0.174561 -0.496826,0 -0.953369,0.187989 -0.443115,0.187988 -0.805664,0.644531 -0.349121,0.443115 -0.550537,1.154785 -0.201416,0.71167 -0.214844,1.745605 0.01343,1.007081 0.201416,1.745606 0.201416,0.738525 0.53711,1.208496 0.349121,0.469971 0.778808,0.698242 0.443115,0.228272 0.926514,0.228272 0.147705,0 0.389404,-0.01343 0.255127,-0.02685 0.496826,-0.06714 0.255127,-0.05371 0.483399,-0.134277 0.228271,-0.08057 0.335693,-0.228272 l 0,-2.443847 -1.678467,0 0,-1.101074 3.276368,0 z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrg);
export default __webpack_public_path__ + "static/media/nrg.4c73b23da23b571c933b7b5e614dea43.svg";
export { ForwardRef as ReactComponent };